import type { EditableFieldsConfig } from '@components/EditableFields/EditableFieldsOverlay'
import type { EditableField, EditableFieldValues } from '../SignDocumentCommon/types'

export const buildEditableFieldsConfig = (params: {
  fields: EditableField[]
  values: EditableFieldValues
  onChange: (key: string, value: string) => void
  requiredErrorLabel?: string
  ibanErrorLabel?: string
  onFieldsResolved: (keys: string[]) => void
}): EditableFieldsConfig | undefined => {
  if (!params.fields.length) return undefined

  return {
    fields: params.fields,
    values: params.values,
    onChange: params.onChange,
    requiredErrorLabel: params.requiredErrorLabel,
    ibanErrorLabel: params.ibanErrorLabel,
    onFieldsResolved: params.onFieldsResolved,
  }
}
